<template>
    <section class="font-poppins">
       <div class=" border ml-6 p-6 md:ml-0 md:p-2 md:text-sm md:border-0">
           <p class="text-blue-600">Account Settings</p>
           <p>Set up your personal information</p>

           <div v-if="isProfileUpdated" class="border border-green-500 text-green-400 bg-green-100 p-2 mt-4">
               <p>Profile successfully Updated</p>
           </div>
            <div v-if="error" class="border border-red-500 text-green-400 bg-red-100 p-2 mt-4">
               <p>{{error}}</p>
           </div>

           <div class="mt-10">
               <form @submit.prevent="updateProfile">
                   <div>
                       <label class="text-blue-600" for="firstName">First Name</label> <br>
                       <input class="border w-full text-gray-400 p-2 mt-2 rounded-xl" type="text" name="firstName" id="firstName"   :placeholder="user.firstName" v-model="firstName">
                       <p v-if="firstNameValidity === 'invalid' " class="text-xs text-red-500">Please enter your first name</p>
                   </div>

                   <div class="mt-4">
                       <label class="text-blue-600" for="lastName">Last Name</label> <br>
                       <input class="border w-full text-gray-400 p-2 mt-2 rounded-xl" type="text" name="lastName" id="lastName"  :placeholder="user.lastName" v-model="lastName">
                       <p v-if="lastNameValidity === 'invalid' " class="text-xs text-red-500">Please enter your last Name</p>
                   </div>

                   <div class="mt-4">
                       <label class="text-blue-600" for="email">Email Address</label> <br>
                       <input class="border w-full text-gray-400 p-2 mt-2 rounded-xl" type="text" name="email" id="email" :placeholder="user.email"  disabled>
                       <p v-if="emailValidity === 'invalid' " class="text-xs text-red-500">Please enter your email</p>
                   </div>

                    <div class="mt-6 flex">
                        <button class="bg-blue-700 text-white p-2 rounded-xl" >Update Profile</button>
                        <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                    </div>
               </form>
           </div>
       </div>
    </section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            firstName: "",
            lastName: "",
            userId : localStorage.getItem('userId'),
            isLoading : false,
            isProfileUpdated: false,

            firstNameValidity : "",
            lastNameValidity: "",
            emailValidity: "",
            user: [],
            error: ""
        }
    },

    mounted() {
        this.getUser();
        this.networkError();
    },

    methods: {
        updateProfile() {
            if(!this.firstName) {
                this.firstNameValidity = "invalid"
                setTimeout(() => {
                this.firstNameValidity = ""
                }, 3000);
            } else if(!this.lastName) {
                this.lastNameValidity = "invalid"
                setTimeout(() => {
                this.lastNameValidity = ""
                }, 3000);
            } else {
                this.isLoading = true
                axios({
                    method: 'PUT',
                    url: `${url}/v1/web/users/${this.userId}`,
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer' + localStorage.getItem("token"),
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: {
                        firstName: this.firstName,
                        lastName : this.lastName,
                    }
                })
                .then((response) => {
                    this.isLoading = false
                    response;
                    this.firstName = ""
                    this.lastName = ""
                    this.isProfileUpdated = true
                    setTimeout(() => {
                        this.isProfileUpdated = false
                    }, 3000);
                })
                .catch((error) => {
                    console.log(error);
                    this.error = error.response.data.message;
                    setTimeout(() => {
                        this.error = ""
                    }, 3000);
                })
            }
        },

        getUser() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/users/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                }
            })
            .then((response) => {
                this.user = response.data.data
            })
            .catch((error) => {
                console.log(error)
            })
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>